module.exports = __webpack_public_path__ + "static/media/buy_pay_invoice_8.46f9202f.png";